export default __webpack_public_path__ + "static/media/gasag_background_xl2.cab5ae85.jpg";